import React, { useEffect, useState } from "react";
import axios from "axios";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ToWords } from "to-words";

const OrderListTwo = ({
  refreshSignal,
  statusFilter = "",
  courierFilter = "",
  dateFilter = "", // Date filter prop (expects YYYY-MM-DD)
  selectedOrders,
  setSelectedOrders,
  selectedCourier,
  setOrders,
  couriers,
  pageType,
//  generateManifestPDF, // Function passed from parent if needed
}) => {
  const [orders, setOrdersLocal] = useState([]);
  const [error, setError] = useState(null);
  const [staffMembers, setStaffMembers] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");

  // NEW: State for inline editing
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [editingOrderData, setEditingOrderData] = useState(null);


  const [availableProducts, setAvailableProducts] = useState([]);

  useEffect(() => {
      const fetchProducts = async () => {
          try {
              const token = localStorage.getItem("authToken");
              const response = await axios.get("https://astrovidhya.in/api/products", {
                  headers: { Authorization: `Bearer ${token}` },
              });
              setAvailableProducts(response.data); // Store products in state
          } catch (error) {
              console.error("❌ Error fetching products:", error);
          }
      };
  
      fetchProducts();
  }, []);
  

 // ✅ Fix: Ensure the correct date format is sent to backend
 useEffect(() => {
  if (!dateFilter) {
    console.warn("⚠️ No date selected, fetching all orders...");
  }

  const formattedDate = dateFilter ? new Date(dateFilter).toISOString().split("T")[0] : undefined;
  console.log("📅 Sending formatted date to backend:", formattedDate);

  axios
    .get("https://astrovidhya.in/api/orders", {
      params: {
        status: statusFilter,
        courierName: courierFilter,
        order_date: formattedDate, // ✅ Properly formatted date
      },
    })
    .then((response) => {
      console.log("✅ Orders fetched:", response.data.length, "orders");
      setOrders(response.data);
      setOrdersLocal(response.data);
    })
    .catch((error) => {
      console.error("❌ Error fetching orders:", error);
      setError("Failed to fetch orders. Please try again later.");
    });
}, [refreshSignal, statusFilter, courierFilter, dateFilter]);

const updateEditingOrder = async (updatedOrder) => {
  try {
      const token = localStorage.getItem("authToken");

      const response = await axios.put(`https://astrovidhya.in/api/orders/${updatedOrder._id}`, updatedOrder, {
          headers: { Authorization: `Bearer ${token}` }
      });

      console.log("✅ Order updated successfully!", response.data);

      // Update the orders list with the new data
      setOrdersLocal((prevOrders) => 
          prevOrders.map((o) => (o._id === updatedOrder._id ? { ...updatedOrder } : o))
      );

      setEditingOrderId(null); // Exit edit mode
  } catch (error) {
      console.error("❌ Error updating order:", error.response?.data || error.message);
      alert("Failed to update order. Please try again.");
  }
};


const handleDeleteOrder = async (orderId) => {
  if (!window.confirm("Are you sure you want to delete this order?")) return;

  try {
    const token = localStorage.getItem("authToken");

    // Send DELETE request to backend
    await axios.delete(`https://astrovidhya.in/api/orders/${orderId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // ✅ Remove the order from UI
    setOrdersLocal((prevOrders) => prevOrders.filter((order) => order._id !== orderId));

    alert("Order deleted successfully!");
  } catch (error) {
    console.error("❌ Error deleting order:", error.response?.data || error.message);
    alert("Failed to delete the order. Please try again.");
  }
};


  // Select All Orders
  const selectAllOrders = () => {
    const allOrderIds = orders.map((order) => order._id);
    setSelectedOrders(allOrderIds);
  };

  // Clear All Orders
  const clearAllOrders = () => {
    setSelectedOrders([]);
  };

  // Generate CSV for Manifest with additional fields
  const generateManifestCSV = () => {
    if (selectedOrders.length === 0) {
      alert("No orders selected!");
      return [];
    }
    return orders
      .filter((order) => selectedOrders.includes(order._id))
      .map((order) => {
        // Determine COD Amount: if payment_method is 'COD' (case-insensitive), then equals total_amount; otherwise, 0.
        const paymentMethod = order.payment_method ? order.payment_method.toLowerCase() : "";
        const packageAmt = order.total_amount || "0";
        const codAmount = paymentMethod === "cod" ? packageAmt : "0";

        // For product details, use the first product (if available)
        const product = Array.isArray(order.products) && order.products.length > 0 ? order.products[0] : null;
        return {
          "Order ID": order._id.toUpperCase(),
          "Customer Name": order.customer_name || "N/A",
          "Mobile": order.mobile || "N/A",
          "Alternate Mobile": order.customer_mobile_2 || "N/A",
          "Shipping Address": order.shipping_address || "N/A",
          "City": order.city || "N/A",
          "State": order.state || "N/A",
          "District": order.district || "N/A",
          "AWD No.": order.AWD || "N/A",
         "Courier": couriers.find(c => c._id === order.courier)?.name || "N/A",

          "Order Date": order.order_date ? new Date(order.order_date).toLocaleDateString() : "N/A",
          "Approval Status": order.approval_status || "Pending",
          "Order Time": order.order_time || "N/A",
          "Caller": order.caller || "N/A",
          "Products": order.products ? order.products.map((p) => p.productName).join(", ") : "N/A",
          "Total Amount (₹)": packageAmt,
          "Payment Mode": order.payment_method || "Not Specified",
          "Package Amount (₹)": packageAmt,
          "COD Amount (₹)": codAmount,
          "Shipment Weight (kg)": product ? product.weight || "N/A" : "N/A",
          "Shipment Length (cm)": product ? product.length || "N/A" : "N/A",
          "Shipment Breadth (cm)": product ? product.breadth || "N/A" : "N/A",
          "Shipment Height (cm)": product ? product.height || "N/A" : "N/A",
          "Vendor": "Manish Ahir",
          "Return Address": "102 Simrol Road, near Hotel Amber, Mobile No: 7400668735, MHOW DIST INDORE, MP, 453441",
          "Return Pin": "453441",
          "wsybill": "",
          "location": ""
        };
      });
  };

  const generatePDF = () => {
    const pdf = new jsPDF("portrait", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;
    const stickerWidth = 95;
    const margin = 10;
    const quadrants = [
        { x: margin, y: margin },
        { x: pageWidth / 2 + margin / 2, y: margin },
        { x: margin, y: pageHeight / 2 + margin / 2 },
        { x: pageWidth / 2 + margin / 2, y: pageHeight / 2 + margin / 2 }
    ];

    selectedOrders.forEach((orderId, index) => {
        const order = orders.find((o) => o._id === orderId);
        if (order) {
            const { x, y } = quadrants[index % 4];

            // Define All Line Positions
            const linePositions = [0, 10, 20, 34, 40, 48, 54, 60, 76, 82, 88, 94, 100, 116, 136].map(offset => y + offset);
            linePositions.forEach(pos => pdf.line(x, pos, x + stickerWidth, pos));

            // Vertical Lines
            pdf.line(x, linePositions[0], x, linePositions[14]);
            pdf.line(x + stickerWidth, linePositions[0], x + stickerWidth, linePositions[14]);
            pdf.line(x + 40, linePositions[4], x + 40, linePositions[13]);

            // **V.P. Parcel Title**
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(14);
            const vpParcelText = "V.P. Parcel";
            const textWidth = pdf.getTextWidth(vpParcelText);
            pdf.text(vpParcelText, x + stickerWidth / 2 - textWidth / 2, linePositions[1] - 3);

            // **Image Placement**
            const imgWidth = stickerWidth - 10;
            const imgHeight = 8;
            pdf.addImage("/images/hindi4-copy.png", "PNG", x + 5, linePositions[1] + 1, imgWidth, imgHeight);

            // **Labels in Left Column**
            pdf.setFontSize(10);
            pdf.text("NAME:", x + 5, linePositions[5] - 2);
            pdf.text("MOBILE NO:", x + 5, linePositions[6] - 2);
            pdf.text("S/O:", x + 5, linePositions[7] - 2);
            pdf.text("ADDRESS:", x + 5, linePositions[8] - 11);
            pdf.text("CITY/DISTRICT:", x + 5, linePositions[9] - 2);
            pdf.text("STATE:", x + 5, linePositions[10] - 2);
            pdf.text("CALLER:", x + 5, linePositions[11] - 2);
            pdf.text("ORDER NO.:", x + 5, linePositions[12] - 2);
            pdf.text("ITEM:", x + 5, linePositions[13] - 11);

            // **Footer Text**
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8);
            const footerText = [
                "FROM IF UNDELIVERED PLS RETURN TO",
                "PRAGNAY INFO, 102, SIMROL ROAD, NEAR HOTEL AMBER,",
                "MHOW, DIST INDORE, MP, PINCODE 453441"
            ];
            footerText.forEach((line, idx) => pdf.text(line, x + 5, linePositions[13] + 5 + idx * 4));

            // **VPP AMOUNT (Total Amount - 5%)**
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(12);
            const fivePercent = Math.floor(order.total_amount * 0.05);  // No decimal
            const adjustedTotalAmount = Math.floor(order.total_amount - fivePercent);  // No decimal
            const vppAmountText = `VPP AMOUNT ${adjustedTotalAmount}`.toUpperCase();
            const vppTextWidth = pdf.getTextWidth(vppAmountText);
            pdf.text(vppAmountText, x + stickerWidth / 2 - vppTextWidth / 2, linePositions[3] - 3);

            // **5% Calculation Table**
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(6);
            pdf.text(`${adjustedTotalAmount}`, x + 22, linePositions[0] + 18);
            pdf.text(`${fivePercent}`, x + 47, linePositions[0] + 18);
            pdf.text(`${Math.floor(order.total_amount)}`, x + 58, linePositions[0] + 18);  // No decimal

            // **Convert Adjusted Total Amount to Words**
            const toWords = new ToWords({
                localeCode: "en-IN",
                converterOptions: { currency: false, ignoreDecimal: true, ignoreZeroCurrency: true },
            });
            const amountInWords = `${toWords.convert(adjustedTotalAmount).toUpperCase()} RS. ONLY`;
            pdf.setFontSize(8);
            const amountWordsWidth = pdf.getTextWidth(amountInWords);
            pdf.text(amountInWords, x + (stickerWidth / 2) - (amountWordsWidth / 2), linePositions[4] - 2);

            // **Right Column Dynamic Data**
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(10);
            pdf.text((order.customer_name || "UNKNOWN").toUpperCase(), x + 45, linePositions[5] - 2);
            pdf.text((order.mobile || "UNKNOWN").toUpperCase(), x + 45, linePositions[6] - 2);
            pdf.text((order.so || "N/A").toUpperCase(), x + 45, linePositions[7] - 2);

            // **Address with Reduced Line Spacing**
            pdf.setFontSize(6);
            const addressLines = strictWordWrap(order.shipping_address || "UNKNOWN", 34, 3).toUpperCase().split("\n");
            addressLines.forEach((line, idx) => pdf.text(line, x + 45, linePositions[8] - 11 + idx * 3));

            pdf.setFontSize(8);
            pdf.text(`${(order.city || "UNKNOWN").toUpperCase()} / ${(order.district || "UNKNOWN").toUpperCase()}`, x + 45, linePositions[9] - 2);
            pdf.text((order.state || "UNKNOWN").toUpperCase(), x + 45, linePositions[10] - 2);
            pdf.text((order.order_no?.toUpperCase() || "UNKNOWN"), x + 45, linePositions[12] - 2);

            // **Item List (Max 4 Lines)**
            pdf.setFontSize(6);
            const productNames = (order.products || []).map(p => p.productName.toUpperCase());
            const displayedProducts = productNames.slice(0, 4);
            displayedProducts.forEach((product, idx) => {
                pdf.text(product, x + 45, linePositions[13] - 11 + idx * 5);
            });

        }
    });

    pdf.save("Grid_Structure.pdf");
};

// **Strict Word Wrapping Function**
const strictWordWrap = (text, maxCharsPerLine, maxLines) => {
    if (!text) return "";

    let words = text.split(" ");
    let lines = [];
    let line = "";

    for (let word of words) {
        if ((line + word).length <= maxCharsPerLine) {
            line += (line.length === 0 ? "" : " ") + word;
        } else {
            lines.push(line);
            line = word;
            if (lines.length >= maxLines - 1) break;
        }
    }
    lines.push(line);
    return lines.slice(0, maxLines).join("\n");
};








  const generateManifestPDF = async () => {
    const pdf = new jsPDF("portrait");
    const courierName = couriers.find(c => c._id === courierFilter)?.name || "N/A";
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text(`${courierName.toUpperCase()}`, 10, 20);
    pdf.setFontSize(12);
    pdf.text(`Date: ${new Date().toLocaleDateString()}`, 10, 30);
    pdf.setFontSize(10);
    const addressX = pdf.internal.pageSize.width - 80;
    pdf.text("PRAGNAY INFO", addressX, 20);
    pdf.text("102 Simrol Road, near Hotel Amber", addressX, 30);
    pdf.text("Mobile No: 7400668735", addressX, 40);
    pdf.text("MHOW DIST INDORE, MP, 453441", addressX, 50);
    const tableHeaders = ["S.No", "Customer Name", "Product", "AWD No.", "Order No."];
    const tableData = [];
    for (let index = 0; index < selectedOrders.length; index++) {
      const order = orders.find(o => o._id === selectedOrders[index]);
      if (order) {
        await sendWhatsAppMessage(order);
        
      
        const productList = order.products
        ? order.products.slice(0, 4).map((p) => p.productName).join("\n") // ✅ Force new lines for up to 4 products
        : "N/A";
      
      // Push data into table with multi-line products
      tableData.push([
        index + 1,
        order.customer_name || "N/A",
        { content: productList, styles: { cellWidth: "wrap", fontSize: 9 } }, // ✅ Multi-line support for products
        order.AWD || "N/A",
        order.order_no.toUpperCase() || "N/A"
      ]);
      

      }
    }
    pdf.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 60,
      theme: 'grid',
      headStyles: {
        fillColor: [3, 201, 215],
        textColor: [255, 255, 255],
        fontSize: 10,
        fontStyle: 'bold',
        halign: "center"
      },
      bodyStyles: {
        fontSize: 10
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      }
    });
    let finalY = pdf.autoTable.previous.finalY + 20;
    if (finalY + 50 > pdf.internal.pageSize.height) {
      pdf.addPage();
      finalY = 20;
    }
    const imgWidth = 180;
    const imgHeight = 50;
    const imgX = (pdf.internal.pageSize.width - imgWidth) / 2;
    pdf.addImage('../images/sysgendoc.png', 'PNG', imgX, finalY, imgWidth, imgHeight);
    let footerY = finalY + imgHeight + 10;
    if (footerY + 15 > pdf.internal.pageSize.height) {
      pdf.addPage();
      footerY = 20;
    }
    pdf.setFontSize(9);
    pdf.text("This is a system-generated document.", 10, footerY);
    pdf.save(`Manifest_${courierName.replace(/\s+/g, "_")}.pdf`);
  };

  // NEW: Function to generate Money Order PDF using a background image and dynamic fields.
// Measurements are in millimeters (mm). (1 cm = 10 mm)
// A4 page: 210 mm x 297 mm.
// Import jsPDF and ToWords at the top of your file if not already imported
// import jsPDF from "jspdf";
// import { ToWords } from "to-words";

const generateMoneyOrderPDF = () => {
  if (selectedOrders.length === 0) {
    alert("No orders selected!");
    return;
  }
  
  // Create a new jsPDF instance for an A4 page (default unit: mm)
  const pdf = new jsPDF("portrait", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();   
  const pageHeight = pdf.internal.pageSize.getHeight(); 
  const horizontalMargin = 20; 
  const verticalMargin = 10;   
  const margin = 10;

  // Instantiate ToWords for converting numbers to words
  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: { currency: false, ignoreDecimal: true, ignoreZeroCurrency: true },
  });

  // Loop through each selected order and create one page per order.
  for (let i = 0; i < selectedOrders.length; i++) {
    const order = orders.find((o) => o._id === selectedOrders[i]);
    if (!order) continue;
    
    if (i > 0) {
      pdf.addPage();
    }

    // 1) ADD THE BACKDROP FIRST, covering the entire page:
    pdf.addImage("/images/backdrop.png", "PNG", 0, 0, pageWidth, pageHeight);

    // 2) Header Section
    const headingImgWidth = 50; 
    const headingImgHeight = 15; 
    const headingImgX = margin + 5;
    const headingImgY = margin + 5;

    const logoWidth = 30; 
    const logoHeight = 15; 
    const logoX = pageWidth - margin - logoWidth - 5;
    const logoY = margin + 5;

    const subHeadingImgWidth = 40;
    const subHeadingImgHeight = 15;
    const subHeadingImgX = horizontalMargin + 5;
    const subHeadingImgY = verticalMargin + 25; 

    // Dynamic total_amount (numeric) in bold
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(24);
    const amountText = `${order.total_amount} /-`;
    const amountX = subHeadingImgX + subHeadingImgWidth + 5;
    pdf.text(amountText, amountX - 6, subHeadingImgY + 4);
    
    // Amount in words 
    pdf.setFontSize(12);
    const amountInWords = `${toWords.convert(order.total_amount || 0)} Rs. only`;
    const wordsX = margin + 24;
    const wordsY = subHeadingImgY + 15;
    pdf.text(amountInWords, wordsX, wordsY);
    
    // Partition & Table images
    const partitionImgX = horizontalMargin + 5;
    const partitionImgY = verticalMargin + 55;

    const tableImgX = horizontalMargin + 5;
    const tableImgY = verticalMargin + 65;

    const middleImgX = horizontalMargin + 5;
    const middleImgY = verticalMargin + 130;

    const bottomImgX = horizontalMargin + 5;
    const bottomImgY = verticalMargin + 200;

    // Large Amount
    const BigX = horizontalMargin + 25;
    const BigY = verticalMargin + 78;
    pdf.setFontSize(36);
    pdf.text(amountText, BigX, BigY);

    // Small Amount in words (wrapped)
    pdf.setFontSize(10);
    const wrapWidth = 50;  
    const SmallamountInWords = `${toWords.convert(order.total_amount || 0)} Rs. only`;
    const lines = pdf.splitTextToSize(SmallamountInWords, wrapWidth);
    const SmallwordsX = horizontalMargin + 25;
    const SmallwordsY = verticalMargin + 87;
    pdf.text(lines, SmallwordsX, SmallwordsY);

    // Small Rs. text
    const smallX = horizontalMargin + 25;
    const smallY = verticalMargin + 98;
    pdf.setFontSize(10);
    pdf.text(`Rs. ${order.total_amount} /-`, smallX, smallY);

    // Right Side Small Amount
    pdf.setFontSize(8);
    pdf.text(SmallamountInWords, horizontalMargin + 90, verticalMargin + 116);
    
    const rightCellX = horizontalMargin + 112;
    const rightCellY = verticalMargin + 132;
    pdf.setFontSize(20);
    pdf.text(`${order.total_amount} /-`, rightCellX, rightCellY);

    // ✅ Customer Details (🔥 FIXED `.toUpperCase()` issue)
    pdf.setFontSize(12);
    
    const customerName = order.customer_name ? order.customer_name.toUpperCase() : "";
    pdf.text(customerName, horizontalMargin + 80, verticalMargin + 213);

    const so = order.so ? order.so.toUpperCase() : "";
    pdf.text(so, horizontalMargin + 80, verticalMargin + 219);

    const address = order.shipping_address ? order.shipping_address.toUpperCase() : "";
    pdf.text(address, horizontalMargin + 80, verticalMargin + 225);

    const city = order.city ? order.city.toUpperCase() : "";
    pdf.text(city, horizontalMargin + 80, verticalMargin + 231);

    const distState = `${order.district || ""} / ${order.state || ""}`;
    pdf.text(distState.toUpperCase(), horizontalMargin + 80, verticalMargin + 237);

    const pin = order.pin ? order.pin.toUpperCase() : "";
    pdf.text(pin, horizontalMargin + 108, verticalMargin + 247);

    const mobile = order.mobile ? order.mobile.toUpperCase() : "";
    pdf.text(mobile, horizontalMargin + 108, verticalMargin + 253);

    // ✅ Order Number (Bottom and Top) - Fixed `.toUpperCase()`
    pdf.setFontSize(7);
    const orderNo = order.order_no ? order.order_no.toUpperCase() : "";
    pdf.text(orderNo, horizontalMargin + 109, verticalMargin + 258);

    pdf.setFontSize(8);
    pdf.text(orderNo, horizontalMargin + 105, verticalMargin + 103);
  }

  // ✅ Save the PDF
  pdf.save("MoneyOrder.pdf");
};









  const sendWhatsAppMessage = async (order) => {
    const apiKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3OTBjZDlhZmI0MTA1MTMyNzA4YmExNCIsIm5hbWUiOiJBc3RybyBWaWRoeWEiLCJhcHBOYW1lIjoiQWlTZW5zeSIsImNsaWVudElkIjoiNjc5MGNkM2Q3MzE5NDIwYzBhMzg5YTFhIiwiYWN0aXZlUGxhbiI6IkZSRUVfRk9SRVZFUiIsImlhdCI6MTczNzU0MzA2Nn0.gMteJY4zu8_2DCkAiVYWvdhlTIhelgBhmIZO9NK2BYU";
    const campaignName = "handover text";
    const destination = `+91${order.mobile}`;
    const templateParams = [
      order.customer_name || "Customer",
      order._id.toUpperCase() || "N/A",
      order.products?.[0]?.productName || "N/A",
      order.tracking_url || "N/A",
      order.courier?.name || "N/A",
      order.tracking_number || "N/A",
      order.estimated_delivery || "N/A"
    ];
    try {
      const response = await axios.post("https://backend.aisensy.com/campaign/t1/api/v2", {
        apiKey,
        campaignName,
        destination,
        templateParams
      });
      console.log("WhatsApp Message Sent ✅", response.data);
    } catch (error) {
      console.error("Error Sending WhatsApp Message ❌", error.response?.data || error.message);
    }
  };

  // Toggle order selection for checkbox clicks
  const toggleOrderSelectionCheckbox = (orderId) => {
    setSelectedOrders((prevSelectedOrders) =>
      prevSelectedOrders.includes(orderId)
        ? prevSelectedOrders.filter((id) => id !== orderId)
        : [...prevSelectedOrders, orderId]
    );
  };

  // For CSV download, use the local orders state (filteredOrders)
  const filteredOrders = orders.filter((order) => {
    const formattedOrderDate = order.order_date
      ? new Date(order.order_date).toISOString().split("T")[0]  // Convert to YYYY-MM-DD
      : "";
  
    return (
      (!dateFilter || formattedOrderDate === dateFilter) &&  // Apply date filter correctly
      (!selectedCourier || order.courier === selectedCourier) &&  // Apply courier filter
      (!statusFilter || order.approval_status === statusFilter)  // Apply status filter
    );
  });
  

  return (
    <div className="order-list-container bg-white p-4 rounded-lg shadow-md">
      <h2 className="text-lg font-bold mb-4">Order List</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse">
        <thead className="bg-gray-200">
    <tr>
        <th>
            <input
                type="checkbox"
                checked={
                    orders.length > 0 &&
                    orders.every((order) => selectedOrders.includes(order._id))
                }
                onChange={(e) =>
                    e.target.checked ? selectAllOrders() : clearAllOrders()
                }
            />
        </th>
        {[
            "#",
            "Customer Name",  // ✅ New Column
            "Mobile",         // ✅ New Column
            "Order Date",
            "Courier",
            "Approval Status",
            "Order Time",
          //  "Caller",
            "Products",
            "Discount (₹)",
            "Total Amount",
            "Payment Method",
        ].map((header) => (
            <th key={header} className="px-4 py-2 text-left font-medium text-gray-700">
                {header}
            </th>
        ))}
        <th className="px-4 py-2 text-left font-medium text-gray-700">Edit</th>
    </tr>
</thead>

<tbody>
  {orders
    .filter((order) => !selectedCourier || order.courier === selectedCourier) // ✅ Apply filtering logic
    .map((order, index) => {
      const isEditing = editingOrderId === order._id;
      return (
        <tr
          key={order._id}
          onClick={() => toggleOrderSelectionCheckbox(order._id)}
          className={`cursor-pointer hover:bg-gray-100 ${
            selectedOrders.includes(order._id) ? "bg-gray-200" : ""
          }`}
        >
          <td className="px-4 py-2">
            <input
              type="checkbox"
              checked={selectedOrders.includes(order._id)}
              onChange={(e) => {
                e.stopPropagation();
                toggleOrderSelectionCheckbox(order._id);
              }}
            />
          </td>
          <td className="px-4 py-2">{index + 1}</td>

          {/* ✅ New Column: Customer Name */}
          <td className="px-4 py-2">
    {editingOrderId === order._id ? (
        <input
            type="text"
            value={editingOrderData?.customer_name || ""}
            onChange={(e) =>
                setEditingOrderData((prev) => ({ ...prev, customer_name: e.target.value }))
            }
            className="px-2 py-1 border rounded"
        />
    ) : order.customer_name ? (
        order.customer_name
    ) : (
        "N/A"
    )}
</td>


          {/* ✅ New Column: Mobile */}
          <td className="px-4 py-2">
            {order.mobile ? order.mobile : "N/A"}
          </td>

          <td className="px-4 py-2">
    {editingOrderId === order._id ? (
        <input
            type="date"
            value={editingOrderData?.order_date ? editingOrderData.order_date.split("T")[0] : ""}
            onChange={(e) =>
                setEditingOrderData((prev) => ({ ...prev, order_date: e.target.value }))
            }
            className="px-2 py-1 border rounded"
        />
    ) : order.order_date ? (
        new Date(order.order_date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric"
        })
    ) : (
        "N/A"
    )}
</td>


          {/* Other columns remain unchanged */}
          <td className="px-4 py-2">
    {editingOrderId === order._id ? (
        <select
            value={editingOrderData?.courier || ""}
            onChange={(e) =>
                setEditingOrderData((prev) => ({ ...prev, courier: e.target.value }))
            }
            className="px-2 py-1 border rounded"
        >
            <option value="">Select Courier</option>
            {couriers.map((c) => (
                <option key={c._id} value={c._id}>
                    {c.name}
                </option>
            ))}
        </select>
    ) : order.courier ? (
        couriers.find((c) => c._id === order.courier)?.name || "Unknown Courier"
    ) : (
        "N/A"
    )}
</td>

          <td className="px-4 py-2">{order.approval_status || "Pending"}</td>
          <td className="px-4 py-2">{order.order_time || "N/A"}</td>
       {/*   <td className="px-4 py-2">{order.assigned_to ? String(order.assigned_to) : "Unassigned"}</td>  */}
       <td className="px-4 py-2">
    {editingOrderId === order._id ? (
        <div>
            {editingOrderData?.products?.map((product, productIndex) => (
                <div key={productIndex} className="flex space-x-2 mb-1">
                    {/* Product Selection Dropdown */}
                    <select
                        value={product.productName || ""}
                        onChange={(e) => {
                            const updatedProducts = [...editingOrderData.products];
                            updatedProducts[productIndex].productName = e.target.value;
                            setEditingOrderData((prev) => ({ ...prev, products: updatedProducts }));
                        }}
                        className="px-2 py-1 border rounded w-2/3"
                    >
                        <option value="">Select Product</option>
                        {availableProducts.map((p) => (
                            <option key={p._id} value={p.productName}>
                                {p.productName}
                            </option>
                        ))}
                    </select>

                    {/* Quantity Input */}
                    <input
                        type="number"
                        value={product.quantity || ""}
                        onChange={(e) => {
                            const updatedProducts = [...editingOrderData.products];
                            updatedProducts[productIndex].quantity = e.target.value;
                            setEditingOrderData((prev) => ({ ...prev, products: updatedProducts }));
                        }}
                        className="px-2 py-1 border rounded w-1/3"
                    />
                </div>
            ))}
        </div>
    ) : (
        // Show products as "Product Name (xQuantity)"
        order.products?.length > 0 ? (
            order.products.map((p) => `${p.productName} (x${p.quantity})`).join(", ")
        ) : (
            "No products selected"
        )
    )}
</td>


          <td className="px-4 py-2">
    {editingOrderId === order._id ? (
        <input
            type="number"
            value={editingOrderData?.discount || ""}
            onChange={(e) =>
                setEditingOrderData((prev) => ({ ...prev, discount: e.target.value }))
            }
            className="px-2 py-1 border rounded"
        />
    ) : order.discount ? (
        `₹${order.discount}`
    ) : (
        "N/A"
    )}
</td>

          <td className="px-4 py-2">
    {editingOrderId === order._id ? (
        <input
            type="number"
            value={editingOrderData?.total_amount || ""}
            onChange={(e) =>
                setEditingOrderData((prev) => ({ ...prev, total_amount: e.target.value }))
            }
            className="px-2 py-1 border rounded"
        />
    ) : order.total_amount ? (
        `₹${order.total_amount}`
    ) : (
        "N/A"
    )}
</td>

<td className="px-4 py-2">
    {editingOrderId === order._id ? (
        <select
            value={editingOrderData?.payment_method || ""}
            onChange={(e) =>
                setEditingOrderData((prev) => ({ ...prev, payment_method: e.target.value }))
            }
            className="px-2 py-1 border rounded"
        >
            <option value="">Select</option>
            <option value="COD">COD</option>
            <option value="Prepaid">Prepaid</option>
        </select>
    ) : order.payment_method ? (
        order.payment_method
    ) : (
        "N/A"
    )}
</td>

<td className="px-4 py-2 flex gap-2">
  {isEditing ? (
    <button
      onClick={(e) => {
        e.stopPropagation();
        updateEditingOrder(editingOrderData);
      }}
      className="bg-blue-500 text-white px-2 py-1 rounded"
    >
      Save
    </button>
  ) : (
    <button
      onClick={(e) => {
        e.stopPropagation();
        setEditingOrderId(order._id);
        setEditingOrderData({ ...order });
      }}
      className="bg-gray-500 text-white px-2 py-1 rounded"
    >
      Edit
    </button>
  )}

  {/* Cancel Button - Deletes Order */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      handleDeleteOrder(order._id);
    }}
    className="bg-red-500 text-white px-2 py-1 rounded"
  >
    Cancel
  </button>
</td>

        </tr>
      );
    })}
</tbody>


        </table>
      </div>
      {/* Additional Buttons */}
      <div className="mt-4 flex space-x-4">
        <button onClick={selectAllOrders} className="bg-[#66DDEB] text-white px-4 py-2 rounded w-1/6">
          Select All
        </button>
        <button onClick={clearAllOrders} className="bg-gray-500 text-white px-4 py-2 rounded w-1/6">
          Clear All
        </button>
        <button
          onClick={generateManifestPDF}
          className="generate-manifest-btn bg-[#03C9D7] text-white px-4 py-2 rounded w-1/6"
        >
          Download Manifest & Initiate Dispatch
        </button>
        <button
          onClick={generatePDF}
          className="generate-sticker-btn bg-[#0292A8] text-white px-4 py-2 rounded w-1/6"
        >
          Generate Sticker(s)
        </button>
        <CSVLink
  data={selectedOrders.length > 0 ? generateManifestCSV() : []}

  filename={`Manifest_${new Date().toISOString().split("T")[0]}.csv`}
  onClick={(e) => {
    if (selectedOrders.length === 0) {
      e.preventDefault();
      alert("Please select at least one order before downloading.");
    } else {
    //  generateManifestCSV(); // Ensures it's not greyed out
    }
  }}
  className={`download-manifest-csv text-white px-4 py-2 rounded w-1/6 ${
    selectedOrders.length === 0 ? "bg-gray-400 cursor-not-allowed" : "bg-[#056F82] hover:bg-[#045566] transition-colors"
  }`}
>
  Download Manifest CSV
</CSVLink>

        <button
  onClick={generateMoneyOrderPDF}
  className="genereate-money-order bg-[#056F82] text-white px-4 py-2 rounded w-1/6"
>
  Generate Money Order
</button>


      </div>
    </div>
  );
};

export default OrderListTwo;
